import { action, makeObservable, observable } from 'mobx';

class SidebarStore {
  logoutToggle = false;
  sidebarToggle = false;
  scannerToggle = false;
  showSideBar = true;
  parentRoute = '';
  childRoute = '';
  isUserManagementEnabled = false;
  isCustomerSegmentsEnabled = false;
  isReviewsEnabled = false;
  isSalesAndOrdersAnalyticsFeatureEnabled: boolean = false;
  isTrafficAnalyticsFeatureEnabled: boolean = false;
  isOperationsAnalyticsFeatureEnabled: boolean = false;
  isReportsAnalyticsFeatureEnabled: boolean = false;

  constructor() {
    makeObservable(this, {
      logoutToggle: observable,
      sidebarToggle: observable,
      scannerToggle: observable,
      parentRoute: observable,
      childRoute: observable,
      isUserManagementEnabled: observable,
      isCustomerSegmentsEnabled: observable,
      isReviewsEnabled: observable,
      isSalesAndOrdersAnalyticsFeatureEnabled: observable,
      isTrafficAnalyticsFeatureEnabled: observable,
      isOperationsAnalyticsFeatureEnabled: observable,
      isReportsAnalyticsFeatureEnabled: observable,

      setSidebarToggle: action,
      setLogoutToggleTrue: action,
      setLogoutToggleFalse: action,
      handleLogout: action,
      handleScannerToggle: action,
      showSideBar: observable,
      setShowSideBar: action,
      setParentRoute: action,
      setChildRoute: action,
      setIsUserManagementEnabled: action,
      setIsReviewsEnabled: action,
      setIsSalesAndOrdersAnalyticsFeatureEnabled: action,
      setIsTrafficAnalyticsFeatureEnabled: action,
      setIsOperationsAnalyticsFeatureEnabled: action,
      setIsReportsAnalyticsFeatureEnabled: action,
    });
  }

  setIsUserManagementEnabled = (isUserManagementEnabled: boolean) => {
    this.isUserManagementEnabled = isUserManagementEnabled;
  }

  setIsCustomerSegmentsEnabled = (isCustomerSegmentsEnabled: boolean): void => {
    this.isCustomerSegmentsEnabled = isCustomerSegmentsEnabled;
  };

  setIsReviewsEnabled = (isReviewsEnabled: boolean): void => {
    this.isReviewsEnabled = isReviewsEnabled;
  };

  setParentRoute = (route: string): void => {
    this.parentRoute = route;
  }

  setIsSalesAndOrdersAnalyticsFeatureEnabled = (value: boolean): void => {
    this.isSalesAndOrdersAnalyticsFeatureEnabled = value;
  };

  setIsTrafficAnalyticsFeatureEnabled = (value: boolean): void => {
    this.isTrafficAnalyticsFeatureEnabled = value;
  };

  setIsOperationsAnalyticsFeatureEnabled = (value: boolean): void => {
    this.isOperationsAnalyticsFeatureEnabled = value;
  };

  setIsReportsAnalyticsFeatureEnabled = (value: boolean): void => {
    this.isReportsAnalyticsFeatureEnabled = value;
  };

  setChildRoute = (route: string): void => {
    this.childRoute = route;
  }

  handleLogout() {
    localStorage.clear();
  }

  setSidebarToggle = () => {
    this.sidebarToggle = !this.sidebarToggle;
  };
  setLogoutToggleTrue() {
    this.logoutToggle = true;
  }
  setLogoutToggleFalse() {
    this.logoutToggle = false;
  }

  handleScannerToggle = () => {
    this.scannerToggle = !this.scannerToggle;
  };

  setShowSideBar = (value: boolean): void => {
    this.showSideBar = value;
  };
}

export const sidebarStore = new SidebarStore();
